import { useEffect } from "react"

interface UseInertElementProps {
  element: HTMLElement | null
  condition?: boolean
}

export function useInertElement({ element, condition }: UseInertElementProps) {
  useEffect(() => {
    if (condition) {
      element?.setAttribute("inert", "")
    } else {
      element?.removeAttribute("inert")
    }
  }, [condition, element])
}
